/* eslint-disable */
// src/utils/machineLabels.js

const OVERRIDES = {
  Tragamoneda: { singular: "Tragamoneda", plural: "Tragamonedas", gender: "f" },
  Pool:        { singular: "Pool",        plural: "Pooles",       gender: "m" },
  Tejo:        { singular: "Tejo",        plural: "Tejos",        gender: "m" },
  Rockola:     { singular: "Rockola",     plural: "Rockolas",     gender: "f" },
  Peluchera:   { singular: "Peluchera",   plural: "Pelucheras",   gender: "f" },
};


const cap = (s) => (!s ? s : s.charAt(0).toUpperCase() + s.slice(1));

function pluralizeEs(word) {
  if (!word) return word;
  const w = String(word);
  const last = w.slice(-1).toLowerCase();

  if ("aeiouáéíóú".includes(last)) return w + "s";
  if (last === "z") return w.slice(0, -1) + "ces";
  if (last === "s" || last === "x") return w;
  return w + "es";
}

export function machineTypeLabel(type, count = 1, { capitalize = true } = {}) {
  const t = String(type ?? "");
  const ov = OVERRIDES[t];
  const singular = ov?.singular ?? t;
  const plural   = ov?.plural   ?? pluralizeEs(t);
  const text = count === 1 ? singular : plural;
  return capitalize ? cap(text) : text;
}

export function rentedGroupTitle(count = 1, { capitalize = true } = {}) {
  const base = count === 1 ? "máquina alquilada" : "máquinas alquiladas";
  return capitalize ? cap(base) : base;
}

export function machineTypeGender(type) {
  const t = String(type ?? "");
  return OVERRIDES[t]?.gender || "f";
}
